<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        :title="`Histórico de baixa (${material.descricao})`"
        large
        ref="Modal"
    >
        <List
            :material="material"
            ref="List"
        />
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        material: {},
    }),
    methods: {
        open(material) {

            this.material = material

            this.$refs.Modal.show()
        },
    }
}
</script>